const hi = {
  "भाजपा सदस्यता अभियान - 2024": "भाजपा सदस्यता अभियान - 2024",
  "Select Language": "भाषा चुने",
  Next: "अगला",
  "Enter your mobile number": "अपना मोबाइल संख्या दर्ज करे",
  "I accept the Terms and Conditions, and by continuing, I consent to voluntarily become a member of the BJP":
    "मैं नियम और शर्तें स्वीकार करता हूं और जारी रखते हुए, मैं स्वेच्छा से भाजपा का सदस्य बनने के लिए सहमति देता हूं",
  "Get OTP": "ओटीपी प्राप्त करें",
  "Terms and Conditions": "नियम और शर्तें",
  "You must tick the box to continue, as it is mandatory.":
    "आपको जारी रखने के लिए बॉक्स पर टिक करना होगा, क्योंकि यह अनिवार्य है।",
  "Okay, Got it": "ठीक है, समझ गया",
  "Get OTP": "ओटीपी प्राप्त करें",
  "Enter OTP": "ओटीपी दर्ज करें",
  "Resend OTP": "ओटीपी दोबारा भेजें",
  Continue: "जारी रखना",
  "Fill details": "विवरण भरें",
  "Upload Photo": "फोटो अपलोड करें",
  "Profile Photo": "खाते की फोटो",
  "Mobile number": "मोबाइल नंबर",
  "Mrs.": "श्रीमती",
  "Mr.": "श्री",
  Ms: "एमएस",
  "Full Name*": "पूरा नाम *",
  "D.O.B": "जन्मतिथि",
  Age: "आयु",
  Gender: "लिंग",
  Female: "महिला",
  Male: "पुरुष",
  Other: "अन्य",
  "Email Id": "ईमेल आईडी",
  "Add address": "पता जोड़ें",
  "House/ Flat/ Floor No.": "मकान/फ्लैट/मंजिल नं.",
  "Current address PIN code": "वर्तमान पता पिन कोड",
  "District*": "ज़िला*",
  State: "राज्य",
  "Assembly constituency (AC)": "विधानसभा क्षेत्र (एसी)",
  "Tell us about your location": "हमें अपने स्थान के बारे में बताएं",
  "It will assist us in locating other members in your area.":
    "यह आपके क्षेत्र में अन्य सदस्यों का पता लगाने में हमारी सहायता करेगा।",
  "Your address as fetched": "आपका पता लाया गया",
  "Referral code": "रेफरल कोड",
  "I certify that above provided information is correct and there is no mistake. I know that all further communication will be done on above provided details":
    "मैं प्रमाणित करता हूं कि ऊपर दी गई जानकारी सही है और कोई गलती नहीं है। मुझे पता है कि आगे का सारा संचार ऊपर दिए गए विवरण के आधार पर किया जाएगा",
  Save: "बचाना",
  Select: "चुनना",
  Camera: "कैमरा",
  or: "या",
  Gallery: "गैलरी",
  "Support format : Jpeg, Png, Pdf": "समर्थन प्रारूप: जेपीईजी, पीएनजी, पीडीएफ",
  Cancel: "रद्द करना",
  "Select location": "स्थान चुनें",
  "Provide location": "स्थान प्रदान करें",
  "Search results": "खोज के परिणाम",
  "Search for a building, street name or..":
    "किसी भवन, सड़क का नाम या... खोजें",
  "Your address as fetched": "आपका पता लाया गया",
  "Locate me": "मेरा पता लगाओ",
  "Confirm location": "स्थान की पुष्टि करें",
  "Congratulations !": "बधाई हो !",
  "Your primary Id is -": "आपकी प्राथमिक आईडी है -",
  "Login in to Bjp.org/membership to enhance your data, access your ID card, and refer others to join as primary members.":
    "अपना डेटा बढ़ाने, अपने आईडी कार्ड तक पहुंचने और अन्य लोगों को प्राथमिक सदस्यों के रूप में शामिल होने के लिए संदर्भित करने के लिए Bjp.org/membership पर लॉग इन करें।",
  "ID CARD": "आईडी कार्ड",
  "You can download your generated ID Card":
    "आप अपना जेनरेट किया हुआ आईडी कार्ड डाउनलोड कर सकते हैं",
  Download: "डाउनलोड करना",
  "Go to dashboard": "डैशबोर्ड पर जाएँ",
  "View your profile": "अपनी प्रोफ़ाइल देखें",
  "Refer and add member": "देखें और सदस्य जोड़ें",
  Share: "शेयर करना",
  "To update your additional details and refer more member, please click here.":
    "अपने अतिरिक्त विवरण अपडेट करने और अधिक सदस्यों को संदर्भित करने के लिए, कृपया यहां क्लिक करें।",
  "Bharatiya Janata Party": "भारतीय जनता पार्टी",
  "6A, DEENDAYAL UPADHYAYA MARG, NEW DELHI - 110002":
    "6ए, दीनदयाल उपाध्याय मार्ग, नई दिल्ली - 110002",
  Name: "नाम",
  "Membership Number": "सदस्यता संख्या",
  "QR Code": "क्यू आर संहिता",
  "Please select a year between 1930 and 2006.":
    "कृपया 1930 और 2006 के बीच का एक वर्ष चुनें।",
  "Please enter a valid email address.": "कृपया एक मान्य ईमेल भरे।",
  "Please enter 6-digit PIN code.": "कृपया 6 अंकों का पिन कोड दर्ज करें।",
  "10-digit mobile number.": "10 अंकों का मोबाइल नंबर.",
  "Please enter a 10-digit mobile number.":
    "कृपया 10 अंकों का मोबाइल नंबर दर्ज करें।",
  "Please enter your name.": "कृपया अपना नाम दर्ज करें।",
  "I pledge and willing to receive regular updates from BJP":
    "मैं प्रतिज्ञा करता हूं और भाजपा से नियमित अपडेट प्राप्त करने का इच्छुक हूं",
  "Get Verification Code": "सत्यापन कोड प्राप्त करें",
  "Enter Verification Code": "सत्यापन कोड दर्ज करें",
  "Resend Verification Code": "सत्यापन कोड पुनः भेजें",
  "Provide Details": "विवरण प्रदान करें",
  Upload: "अपलोड करें",
  Ok: "ठीक है",
  Calendar: "कैलेंडर",
  "Full Address": "पूरा पता",
  "Privacy policy": "गोपनीयता नीति",
  Disclaimer: "अस्वीकरण",
  "Contact us": "हमसे संपर्क करें",
  Save: "सहेजें",
  "Your primary member ID": "आपका प्राथमिक सदस्य आईडी",
  "Membership Card": "सदस्यता कार्ड",
  "Your Unique Referral code": "आपका अद्वितीय संदर्भ कोड",
  "Invite and add member": "निमंत्रण भेजें और सदस्य जोड़ें",
  Share: "साझा करें",
  "Click below to add more details, donate and add other members to BJP":
    "नीचे क्लिक कर विवरण जोड़ें, दान करें और अन्य सदस्यों को भाजपा में जोड़ें",
  "Update your details": "अपने विवरण अपडेट करें",
  "Add Referral Details": "संदर्भ विवरण जोड़ें",
  "Referred by (name)": "संदर्भित द्वारा (नाम)",
  "Referred by (mobile number)": "संदर्भित द्वारा (मोबाइल नंबर)",
  Capture: "फोटो खींचे",
  "Close Camera": "कैमरा बंद करें",
  Uploading: "अपलोड हो रहा है",
  "Your Unique Referral Link": "आपका रेफरल लिंक",
  "You've reached the maximum OTP attempts for today. Please try again tomorrow":
    "आप आज के लिए अधिकतम OTP प्रयासों तक पहुंच गए हैं. कृपया कल पुनः प्रयास करें",
  " is not a Primary Member, Only Primary Members can refer.": "",
  Miss: "सुश्री",
  "OTP limit reached for today. Please try again tomorrow":
    "आज के लिए OTP सीमा समाप्त हो गई. कृपया कल पुनः प्रयास करें",
  ": is not a Primary Member, Only Primary Members can refer":
    ": प्राथमिक सदस्य नहीं है, केवल प्राथमिक सदस्य ही रेफेर कर सकते हैं",
  "Please enter valid fullname": "कृपया पूरा नाम दर्ज करें",
  "Full Name": "पूरा नाम",
  Upload: "अपलोड करें",
};

export default hi;
